import React from 'react';
import ShoppingCartMvp from './ShoppingCartMvpAutoSync';
import { CrossSellProducts } from './CrossSellProducts';
import { GetFlag } from '../../../../utils/featureFlag';
import {
  FEATURE_FLAG_CROSS_SELL_TOP,
  FEATURE_FLAG_CROSS_SELL_VERTICAL,
  CROSS_SELL_VERTICAL_BREAKPOINT
} from '../../../../utils/cross-sell';
import useIsScreenSmallerThan from '../../../../hooks/useIsScreenSmallerThan';
import { WrapperContainer, CartContent } from './ShoppingCartWrapper.styles';

interface ShoppingCartWrapperProps {
  crossSellKey?: string;
  setCrossSellKey?: React.Dispatch<React.SetStateAction<string>>;
  autoSyncLoading?: boolean;
  setAutoSyncLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ShoppingCartWrapperAutoSync: React.FC<
  ShoppingCartWrapperProps
> = ({
  crossSellKey: externalCrossSellKey,
  setCrossSellKey: externalSetCrossSellKey,
  autoSyncLoading: externalAutoSyncLoading,
  setAutoSyncLoading: externalSetAutoSyncLoading
}) => {
  const [internalCrossSellKey, internalSetCrossSellKey] = React.useState('');
  const [internalAutoSyncLoading, internalSetAutoSyncLoading] =
    React.useState(false);

  const autoSyncLoading =
    externalAutoSyncLoading !== undefined
      ? externalAutoSyncLoading
      : internalAutoSyncLoading;
  const setAutoSyncLoading =
    externalSetAutoSyncLoading ?? internalSetAutoSyncLoading;

  // Use external (from LongSteelMvp) if provided, otherwise fallback to local state
  const crossSellKey = externalCrossSellKey ?? internalCrossSellKey;
  const setCrossSellKey = externalSetCrossSellKey ?? internalSetCrossSellKey;

  const crossSellTopFlag = GetFlag(FEATURE_FLAG_CROSS_SELL_TOP);
  const crossSellVerticalFlag = GetFlag(FEATURE_FLAG_CROSS_SELL_VERTICAL);
  const isSmallScreen = useIsScreenSmallerThan(CROSS_SELL_VERTICAL_BREAKPOINT);

  const showVertical = crossSellVerticalFlag && !isSmallScreen;
  const showHorizontal = !showVertical;

  return (
    <WrapperContainer>
      <CartContent>
        {showHorizontal && crossSellTopFlag && (
          <CrossSellProducts
            orientation="horizontal"
            setCrossSellKey={setCrossSellKey}
            syncLoading={autoSyncLoading}
          />
        )}
        <ShoppingCartMvp
          key={crossSellKey}
          crossSellKey={crossSellKey}
          autoSyncLoading={autoSyncLoading}
          setAutoSyncLoading={setAutoSyncLoading}
        />
        {showHorizontal && !crossSellTopFlag && (
          <CrossSellProducts
            orientation="horizontal"
            setCrossSellKey={setCrossSellKey}
            syncLoading={autoSyncLoading}
          />
        )}
      </CartContent>
    </WrapperContainer>
  );
};
